import React, { useState, useEffect } from "react";
import get from "../../../assets/images/home/darkblue.png";

import { Link } from "react-router-dom";
import "./HeroBanner.scss";
import Waves from "../Waves/Waves";

function HeroBanner() {
  const [scrollY, setScrollY] = useState(0);

  const handleScroll = () => {
    setScrollY(window.scrollY);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <div>
      <section className="hero">
        <div className="content">
          <h1>We transform spaces with experience and creativity...</h1>
          <div className="option">
            <a href="https://app.gethearth.com/financing/42915/74109/prequalify?utm_campaign=42915&utm_content=darkblue&utm_medium=contractor-website&utm_source=contractor&utm_term=74109">
              <img src={get} alt="get my rates" />
            </a>
          </div>
        </div>
        <Waves />
      </section>

      <section id="contenido">
        <div className="container">
          <h2>
            We talk about the client's desire to create a home they love. We
            also offer easy to install and maintain solutions in flooring,
            drywall and paint, which becomes a valuable selling point for our
            customers.
          </h2>
          <p>
            More information <Link to="/about">About Us</Link>
          </p>
        </div>
      </section>
    </div>
  );
}

export default HeroBanner;
